export default __webpack_public_path__ + "4820fab60d47a5b798c85e3e6b2e7386.webp";